import { CANJE_INVALID_TOKEN, CANJE_TOO_MANY_REQUESTS } from './Constantes';

export const GenericErrorHandler = (callback: (message?: string) => void, error?: any) => {
  typeof error === 'string' || typeof error === 'undefined'
    ? callback(error)
    : callback(
        error.networkError && error.networkError.statusCode && error.networkError.statusCode === 500
          ? undefined
          : error.networkError?.result?.Message
      );
};

export const TMRandRetryErrorHandler = (error: any) => {
  if (error.networkError.response.status === 429) return CANJE_TOO_MANY_REQUESTS;
  if (error.networkError.response.status === 409 && error.networkError?.result?.Message.includes('Código')) return CANJE_INVALID_TOKEN;

  return null;
};
